// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d3cd94e","732":"89001345","977":"bad48fcf"}[chunkId] + ".chunk.js";
};